import { GetterTree } from 'vuex'
import { ModuleState, PostStatus } from './types'
import { RootState } from '@/types'

export const getters: GetterTree<ModuleState, RootState> = {
  post(state) { return state.post },
  posts(state) { return state.posts },
  postsByTownByUserByStatus(state, status: PostStatus) { return state.postsByTownByUserByStatus[status] },
  postsByTownByUserPending(state) { return state.postsByTownByUserPending },
  postsByTownByUserActive(state) { return state.postsByTownByUserActive },
  postsByTownByUserInactive(state) { return state.postsByTownByUserInactive }
}
